import { be } from 'date-fns/locale';
import APIService from '../api.service';

export const All = (params) => {
  return APIService.get(`/v01/inventories/all`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      type: params.type,
      warehouse_id: params.warehouse_id,
      category_id: params?.category_id,
      is_low_stock: params?.is_low_stock,
      below_cost: params?.below_cost,
      not_orderable: params?.not_orderable,
    },
  });
};

export const Transaction = (body, config) => {
  return APIService.post(`/v01/inventory-transaction`, body, config);
}

export const History = (id, payload) => {
  return APIService.get(`/v01/inventories/${id}`, {
    params: {
      ...payload,
    }
  });
};

export const ImportOpeningStock = (body, config) => {
  return APIService.post(`/v01/opening-stock`, body, config);
}

export const ExportOpeningStockNotAdded = (warehouseId, config = {}) => {
  return APIService.get(`/v01/opening-stock-not-added`, {
    ...config,
    params: {
      warehouse_id: warehouseId,
    },
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
}

const InventoryService = {
  All,
  Transaction,
  History,
  ImportOpeningStock,
  ExportOpeningStockNotAdded
}

export default InventoryService;